import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import FormFactory from "components/FormFactory";
import get from "lodash/get";
import BrandField from "components/BrandField";
import StripeExternalLink from "components/StripeExternalLink";
import { getStripeDestination } from "utils/stripe";
import Toggle from "react-toggle";
import { getToggleProps } from "utils/form";
import { STATE_KEYS } from "utils/constants/state";
import { STRIPE_ROUTES } from "utils/constants/stripe";
import { useScrollToElement } from "utils/hooks/editor";

const FooterBlock = ({ name, uid, schema }) => {
  const {
    values,
    touched,
    setFieldTouched,
    setFieldValue
  } = useFormikContext();
  useScrollToElement(name);
  const content = get(values, `${name}.data`, {});
  const account = get(values, `${STATE_KEYS.MANIFEST.ADMIN}.account`, {});
  const configPath = `${name}.config`;
  const showBrandPath = `${configPath}.${STATE_KEYS.ENTITY_CONFIG.BRAND_SHOW}`;
  const showBrandTouched = get(touched, showBrandPath);
  const showBrand = Boolean(get(values, showBrandPath));

  return (
    <Fragment>
      {content.brand && (
        <BrandField name={`${name}.data.brand`} brand={content.brand} />
      )}
      <div className="ph3 bg-white bh--inset dib w-100 pv3 bb hairline-1">
        <div className="w-100 flex flex-column">
          <div className="w-100 flex flex-row justify-between items-center">
            <label className="f6 dib fw6">Show brand</label>
            <Toggle
              {...getToggleProps({
                active: showBrand,
                setFieldValue: (_, active) => {
                  setFieldValue(showBrandPath, active);
                  if (!showBrandTouched) {
                    setFieldTouched(showBrandPath, true);
                  }
                }
              })}
            />
          </div>
        </div>
      </div>
      <div className="bg-white flex flex-column fr w-100 bh--inset pt3">
        <div className="ph3 flex justify-end">
          <StripeExternalLink
            account={account}
            copy="Stripe account settings"
            href={getStripeDestination({
              path: STRIPE_ROUTES.ACCOUNT,
              test: false
            })}
          />
        </div>
      </div>
      <FormFactory schema={schema} name={name} uid={uid} />
    </Fragment>
  );
};

FooterBlock.propTypes = {
  name: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired,
  uid: PropTypes.string.isRequired,
  component: PropTypes.string.isRequired,
  schema: PropTypes.object.isRequired
};

export default FooterBlock;
